import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import SheetTitle from '../../../components/SheetTitle';
import { slugify } from '../../../helpers/view';

import c from '../Search.less';

function SeriesBlock({ items }) {
  return (
    <div>
      <SheetTitle title="Series" />
      <ul className={c.seriesList}>
        {
          items.map((item) => (
            <li className={c.tag} key={item.id}>
              <Link to={`/series/${slugify(item.name, item.id)}`}>
                <span>#</span>
                {' '}
                {item.name}
              </Link>
            </li>
          ))
        }
      </ul>
    </div>
  );
}

SeriesBlock.propTypes = {
  items: PropTypes.array.isRequired,
};

export default SeriesBlock;
